import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Clock from "./Clock";
import { Wrapper } from "./styled";
import OddsTypeSelector from "../OddsTypeSelector";
import classNames from "classnames";
import useToggleState from "../../hooks/useToggleState";
import RulesModal from "../RulesModal";

const StatusBar = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { isToggled: isRulesOpen, toggle: toggleRules } = useToggleState();

  return (
    <Wrapper className="py-2 px-4 tablet:px-8">
      <div className="flex justify-between">
        <div>
          <Clock />
        </div>
        <div className="flex space-x-4">
          <OddsTypeSelector />
          <button
            className={classNames(
              "px-3 py-0.5 rounded-full border border-green-800 hover:bg-green-800 hover:text-white",
              {
                "bg-green-800 text-white": location.pathname === "/my-bets",
              }
            )}
            onClick={() => navigate("/my-bets")}>
            {t("My Bets")}
          </button>
          <button
            className={classNames(
              "px-3 py-0.5 rounded-full border border-green-800 hover:bg-green-800 hover:text-white",
              {
                "bg-green-800 text-white": location.pathname === "/statement",
              }
            )}
            onClick={() => navigate("/statement")}>
            {t("Statement")}
          </button>
          <button
            className={classNames(
              "px-3 py-0.5 rounded-full border border-green-800 hover:bg-green-800 hover:text-white",
              {
                "bg-green-800 text-white": location.pathname === "/results",
              }
            )}
            onClick={() => navigate("/results")}>
            {t("All Result")}
          </button>
          <button
            className={classNames(
              "px-3 py-0.5 rounded-full border border-green-800 hover:bg-green-800 hover:text-white",
              {
                "bg-green-800 text-white": isRulesOpen,
              }
            )}
            onClick={toggleRules}>
            {t("Rules and regulations")}
          </button>
        </div>
      </div>
      <RulesModal isToggled={isRulesOpen} onClose={toggleRules} />
    </Wrapper>
  );
};

export default StatusBar;
